import { useFormContext } from "react-hook-form";

const Index = () => {
  const { getValues } = useFormContext();
  const poruke = getValues("poruke");
  return (
    <div>
      {poruke.map((poruka: string) => (
        <p>{poruka}</p>
      ))}
    </div>
  );
};

export default Index;
